import React from 'react';
import { connect } from 'react-redux';

import {
  cancelTransfer,
} from '../../actions';
import {
  cancelOrder,
} from '../../actions/orders';
import {
  cancelOrder as cancelOfferOrder,
} from '../../actions/investment';
import {
  transactionTypes,
} from './lookups';

import './styles.css';


const AVAILABLE_TRANSACTION_TYPES = {
  [transactionTypes.OFFER_TRANSACTION]: 'order',
  [transactionTypes.SECURITY_TRADE]: 'order',
  [transactionTypes.MONEY_TRANSACTION]: 'transfer',
  [transactionTypes.OTHERS]: '',
};

class CancelPendingItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirm: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.toggleConfirm = this.toggleConfirm.bind(this);
  }

  componentWillUnmount() {
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }
  }

  async onSubmit() {
    try {
      this.props.onCancel();
    } catch (err) {
      // set a timeout for the error to return to the normal
      // cancellation state
      const timeout = setTimeout(() => {
        this.setState({ error: '' });
      }, 4500);

      this.setState({
        error: err.message,
        showConfirm: false,
        timeout,
      });
    }
  }

  toggleConfirm() {
    this.setState({ showConfirm: !this.state.showConfirm });
  }

  render() {
    if (this.state.error) {
      return (
        <div styleName="errorCanceling">
          { this.state.error }
        </div>
      );
    }

    if (this.state.showConfirm) {
      return (
        <div>
          <div styleName="cancelConfirmText">
            Are you sure?
          </div>
          <div styleName="cancelOptionContainer">
            <div
              styleName="cancelLink"
              onClick={this.onSubmit}
              onKeyPress={this.onSubmit}
              role="button"
              tabIndex={0}
            >
              Yes
            </div>
            <div
              styleName="cancelLink"
              onClick={this.toggleConfirm}
              onKeyPress={this.toggleConfirm}
              role="button"
              tabIndex={0}
            >
              No
            </div>
          </div>
        </div>
      );
    }

    const type = AVAILABLE_TRANSACTION_TYPES[this.props.transactionType];
    return (
      <div
        styleName="cancelLink"
        onClick={this.toggleConfirm}
        onKeyPress={this.toggleConfirm}
        role="button"
        tabIndex={0}
      >
        {`Cancel ${type}`}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
});

const mapDispatchToProps = {
  cancelOrder,
  cancelTransfer,
  cancelOfferOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelPendingItem);



// WEBPACK FOOTER //
// ./src/components/History/CancelPendingItem.js